// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.test-size-0 {
    display: none;
}

.test-size-1 {
    display: none;
}

.test-size-2 {
    display: none;
}

.test-size-3 {
    display: none;
}

.test-size-4 {
    display: none;
}

.test-size-5 {
    display: none;
}

.test-size-6 {
    display: none;
}

.test-hover-0 {
    display: none;
}

.test-hover-1 {
    display: none;
}

.test-pointer-0 {
    display: none;
}

.test-pointer-1 {
    display: none;
}

.test-pointer-2 {
    display: none;
}

/* nothing */
@media (min-width: 0px) and (max-width: 320px) {
    .test-size-0 {
        display: initial;
    }
}
/* smartphones, iPhone, portrait 480x320 phones */
@media (min-width: 321px) and (max-width: 480px) {
    .test-size-1 {
        display: initial;
    }
}
/* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide */
@media (min-width: 481px) and (max-width: 640px) {
    .test-size-2 {
        display: initial;
    }
}
/* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
@media (min-width: 641px) and (max-width: 960px) {
    .test-size-3 {
        display: initial;
    }
}
/* tablet, landscape iPad, lo-res laptops ands desktops */
@media (min-width: 961px) and (max-width:1024px) {
    .test-size-4 {
        display: initial;
    }
}
/* big landscape tablets, laptops, and desktops */
@media (min-width:1025px) and (max-width:1280px) {
    .test-size-5 {
        display: initial;
    }
}
/* hi-res laptops and desktops */
@media (min-width:1281px) and (max-width:2000px) {
    .test-size-6 {
        display: initial;
    }
}
/* Does not support hover */
@media (hover:none ) {
    .test-hover-0 {
        display: initial;
    }
}
/* Supports hover */
@media (hover:hover ) {
    .test-hover-1 {
        display: initial;
    }
}
/* no pointer */
@media (pointer:none) {
    .test-pointer-0 {
        display: initial;
    }
}
/* coarse pointer */
@media (pointer:coarse) {
    .test-pointer-1 {
        display: initial;
    }
}
/* fine pointer */
@media (pointer:fine) {
    .test-pointer-2 {
        display: initial;
    }
}

`, "",{"version":3,"sources":["webpack://./test.css"],"names":[],"mappings":";AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,iDAAiD;AACjD;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,0EAA0E;AAC1E;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,8FAA8F;AAC9F;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,yDAAyD;AACzD;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,iDAAiD;AACjD;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,gCAAgC;AAChC;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,2BAA2B;AAC3B;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,mBAAmB;AACnB;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,eAAe;AACf;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,mBAAmB;AACnB;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,iBAAiB;AACjB;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["\r\n.test-size-0 {\r\n    display: none;\r\n}\r\n\r\n.test-size-1 {\r\n    display: none;\r\n}\r\n\r\n.test-size-2 {\r\n    display: none;\r\n}\r\n\r\n.test-size-3 {\r\n    display: none;\r\n}\r\n\r\n.test-size-4 {\r\n    display: none;\r\n}\r\n\r\n.test-size-5 {\r\n    display: none;\r\n}\r\n\r\n.test-size-6 {\r\n    display: none;\r\n}\r\n\r\n.test-hover-0 {\r\n    display: none;\r\n}\r\n\r\n.test-hover-1 {\r\n    display: none;\r\n}\r\n\r\n.test-pointer-0 {\r\n    display: none;\r\n}\r\n\r\n.test-pointer-1 {\r\n    display: none;\r\n}\r\n\r\n.test-pointer-2 {\r\n    display: none;\r\n}\r\n\r\n/* nothing */\r\n@media (min-width: 0px) and (max-width: 320px) {\r\n    .test-size-0 {\r\n        display: initial;\r\n    }\r\n}\r\n/* smartphones, iPhone, portrait 480x320 phones */\r\n@media (min-width: 321px) and (max-width: 480px) {\r\n    .test-size-1 {\r\n        display: initial;\r\n    }\r\n}\r\n/* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide */\r\n@media (min-width: 481px) and (max-width: 640px) {\r\n    .test-size-2 {\r\n        display: initial;\r\n    }\r\n}\r\n/* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\r\n@media (min-width: 641px) and (max-width: 960px) {\r\n    .test-size-3 {\r\n        display: initial;\r\n    }\r\n}\r\n/* tablet, landscape iPad, lo-res laptops ands desktops */\r\n@media (min-width: 961px) and (max-width:1024px) {\r\n    .test-size-4 {\r\n        display: initial;\r\n    }\r\n}\r\n/* big landscape tablets, laptops, and desktops */\r\n@media (min-width:1025px) and (max-width:1280px) {\r\n    .test-size-5 {\r\n        display: initial;\r\n    }\r\n}\r\n/* hi-res laptops and desktops */\r\n@media (min-width:1281px) and (max-width:2000px) {\r\n    .test-size-6 {\r\n        display: initial;\r\n    }\r\n}\r\n/* Does not support hover */\r\n@media (hover:none ) {\r\n    .test-hover-0 {\r\n        display: initial;\r\n    }\r\n}\r\n/* Supports hover */\r\n@media (hover:hover ) {\r\n    .test-hover-1 {\r\n        display: initial;\r\n    }\r\n}\r\n/* no pointer */\r\n@media (pointer:none) {\r\n    .test-pointer-0 {\r\n        display: initial;\r\n    }\r\n}\r\n/* coarse pointer */\r\n@media (pointer:coarse) {\r\n    .test-pointer-1 {\r\n        display: initial;\r\n    }\r\n}\r\n/* fine pointer */\r\n@media (pointer:fine) {\r\n    .test-pointer-2 {\r\n        display: initial;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
